<script setup>
import { ref, reactive, computed, onMounted, defineComponent, defineEmits, defineExpose } from 'vue'
import { showToast } from 'vant';
import copy from 'copy-to-clipboard'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, getReqDataNoToken, getCommunicationAPI, changePwdAPI, getVerifyCodeAPI,
  getBindCodeAPI, getUpBindCodeAPI, sendGiftCodeAPI } from '@/util/api'

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})

const showType = ref('index')
const communication = ref('')
const bingdingEmail = ref('')
const bdEmail = ref('')
const bdCode = ref('')
const showBindingGifPop = ref(false)
const modifyReq = ref({
  uid: "",
  uname: "",
  upwd: "",
  scode: "",
  email: '',
  token: '',
  pgid: 59,
})
const newPwd = ref('')
const showPwd = ref(false)
const modifyBindingReq = ref({
  uname: '',
  uid: '',
  token: '',
  pgid: 59,
  scode: '',
  email: '',
  yscode: ''
})

const claimText = ref('')
let codeData = ref([])
const agree = ref(false)
let isWait1 = ref(false)
const timeOut1 = ref(null)
const count1 = ref(60)
let isWait2 = ref(false)
const timeOut2 = ref(null)
const count2 = ref(60)

const getCommunication = () => {
  let reqData = {
    pgid: 59,
    uid: userInfo.value.uid,
    uname: userInfo.value.uname,
    token: userInfo.value.token
  }
  getCommunicationAPI(getReqData(reqData)).then(res => {
    if (res.data.code == 0) {
      console.log('【用户绑定信息】', res.data.data);
      communication.value = res.data.data
      bingdingEmail.value = communication.value.email.replace(
        /(\d{3})\d*(\d{2})/,
        "$1****$2"
      );
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const toFb = () => {
  window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
}
const getVerifyCode = (type, email) => {
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    pgid: 59,
    rid: type,
    email: email
  }
  if (!reqData.email) {
    showToast({ type: 'fail', message: '이메일을 입력해 주세요.', className:'toast-fail' })
    return
  }
  getVerifyCodeAPI(getReqData(reqData)).then(res => {
    console.log('【验证码res】', res);
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      if (type == 309) {
        isWait2.value = true
        delayedCode2()
      } else {
        isWait1.value = true
        delayedCode()
      }
    } else {
      showToast({ type: 'fail', message: res.data.msg.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const getBindCode = (type) => {
  const reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    pgid: 59,
    scode: bdCode.value,
    email: bdEmail.value,
    rid: type
  }
  if (!reqData.email) {
    showToast({ type: 'fail', message: '이메일을 입력해 주세요.', className:'toast-fail' })
    return
  }
  if (!reqData.scode) {
    showToast({ type: 'fail', message: '이메일 인증번호를 입력해주세요.', className:'toast-fail' })
    return
  }
  getBindCodeAPI(getReqDataNoToken(reqData)).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      showBindingGifPop.value = true
      getCommunication()
      updateOperation()
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const sendGiftCode = () => {
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    pgid: 59,
    pid: 45,
    gid: 1000796,
    rid: 310,
    email: '1632650064@qq.com'
  }
  if (!reqData.email) {
    showToast({ type: 'fail', message: '이메일을 입력해 주세요.', className:'toast-fail' })
    return
  }
  sendGiftCodeAPI(getReqData(reqData)).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      showBindingGifPop.value = false
    } else {
      showToast({ type: 'fail', message: res.data.msg.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const changePwd = () => {
  modifyReq.value.uname = userInfo.value.uname
  modifyReq.value.uid = userInfo.value.uid
  modifyReq.value.token = userInfo.value.token
  modifyReq.value.email = communication.value.email
  modifyReq.value.rid = 307
  if (!modifyReq.value.upwd) {
    showToast({ type: 'fail', message: '새 비밀번호를 입력해주세요', className:'toast-fail' })
    return
  }
  if (modifyReq.value.upwd !== newPwd.value) {
    showToast({ type: 'fail', message: '비밀번호가 일치하지 않습니다.', className:'toast-fail' })
    return
  }
  if (!modifyReq.value.scode) {
    showToast({ type: 'fail', message: '이메일 인증번호를 입력해주세요.', className:'toast-fail' })
    return
  }
  changePwdAPI(getReqDataNoToken(modifyReq.value)).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      userStore.setUserInfo('')
      localStorage.removeItem('2G19fZeORY8=')
      localStorage.removeItem('FiJISxKHfpo=')
      setTimeout(() => {
        goLogin()
      }, 1000)
    } else {
      showToast({ type: 'fail', message: res.data.msg.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const getUpBindCode = () => {
  console.log('【userInfo.value】', userInfo.value);
  
  modifyBindingReq.value.uname = userInfo.value.uname
  modifyBindingReq.value.uid = userInfo.value.uid
  modifyBindingReq.value.token = userInfo.value.token
  modifyBindingReq.value.email = bdEmail.value
  modifyBindingReq.value.rid = 304
  if (!modifyBindingReq.value.yscode) {
    showToast({ type: 'fail', message: '이메일 인증번호를 입력해주세요.', className:'toast-fail' })
    return
  }
  if (!modifyBindingReq.value.email) {
    showToast({ type: 'fail', message: '새 이메일 주소를 입력해주세요.', className:'toast-fail' })
    return
  }
  if (!modifyBindingReq.value.scode) {
    showToast({ type: 'fail', message: '이메일 인증번호를 입력해주세요.', className:'toast-fail' })
    return
  }
  getUpBindCodeAPI(getReqDataNoToken(modifyBindingReq.value)).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      getCommunication()
      updateOperation()
      showType.value = 'index'
    } else {
      showToast({ type: 'fail', message: res.data.msg.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const goCustomer = () => {
  if (localStorage.getItem('config-record')) {
    window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
  }
}

const emit = defineEmits(['needLogin', 'goPayPage', 'updateCommunication'])
const goLogin = () => {
  emit('needLogin');
}
const updateOperation = () => {
  emit('updateCommunication');
}

const delayedCode = () => {
  if (count1.value > 0) {
    timeOut1.value = setTimeout(() => {
      count1.value--
      delayedCode()
    }, 1000)
  } else {
    clearTimeout(timeOut1.value)
    isWait1.value = false
    count1.value = 60
  }
}
const delayedCode2 = () => {
  if (count2.value > 0) {
    timeOut2.value = setTimeout(() => {
      count2.value--
      delayedCode2()
    }, 1000)
  } else {
    clearTimeout(timeOut2.value)
    isWait2.value = false
    count2.value = 60
  }
}
const doCopy = (text) => {
  copy(text)
  showToast({ type: 'success', message: 'Link copied successfully, go ahead and share it!', className:'toast-success' })
}

defineExpose({ getCommunication })
onMounted( () => {
  getCommunication()
})
</script>

<template>
  <section class="trade-box">
    <section v-if="showType == 'index'" style="display: flex; flex-direction: column; align-items: center;">
      <img src="@/assets/img/04p/title01.png" alt="" style="height: 0.54rem; margin-top: 0.76rem;">
      <section style="width: 342px; display: flex; flex-direction: column; align-items: flex-start;">
        <img src="@/assets/img/04p/zh-icon.png" alt="" style="height: 0.2rem; margin-top: 0.32rem;">
        <span class="text-style" style="margin: 0.2rem 0rem 0.1rem;">계정</span>
        <aside style="display: flex; align-items: center;">
          <span class="text-box">{{ userInfo.uname }}</span>
          <img src="@/assets/img/04p/xg-btn.png" alt="" @click="showType = 'chuangePwd'" style="height: 0.36rem;">
        </aside>
        <span class="text-style" style="margin: 0.2rem 0rem 0.1rem;">메일 연동</span>
        <aside style="display: flex; align-items: center;">
          <span :class="bingdingEmail ? 'text-box' : 'text-box tips-color'">{{ bingdingEmail ? bingdingEmail : '미연동' }}</span>
          <button v-if="bingdingEmail" class="btn-box" @click="showType = 'modifyBinding'">연동 변경</button>
          <img v-else src="@/assets/img/04p/bd-btn03.png" alt="" @click="showType = 'binding'" style="height: 0.36rem;">
        </aside>
        <span style="display: block; width: 100%; text-align: center; color: rgb(0, 143, 255); font-size: 0.13rem; margin-top: 0.2rem;">이메일 연동을 완료하시면 특별한 연동 보상이 지급됩니다!</span>
        <img src="@/assets/img/04p/lx-icon.png" alt="" style="height: 0.2rem; margin: 0.4rem 0rem 0.2rem;">
        <span @click="toFb" style="font-size: 0.12rem; color: rgb(53, 88, 124);">Facebook</span>
        <span style="font-size: 0.12rem; color: rgb(53, 88, 124); margin-top: 0.2rem;">페이스북에서 "hllcmt" 또는 "우르릉 해적단"을 검색하여 공식 페이지로 문의해주세요.</span>
      </section>
    </section>
    <!-- binding -->
    <section v-if="showType == 'binding'" style="display: flex; flex-direction: column; align-items: center; width: 342px;">
      <img src="@/assets/img/04p/bac-btn02.png" alt="" @click="showType = 'index'" style="position: absolute; top: 0.56rem; left: 0rem; height: 0.5rem;">
      <img src="@/assets/img/04p/title02.png" alt="" style="height: 0.54rem; margin-top: 1.06rem;">
      <section style="width: 342px; display: flex; flex-direction: column; align-items: flex-start;">
        <img src="@/assets/img/04p/bd-icon.png" alt="" style="height: 0.2rem; margin-top: 0.2rem;">
        <!-- <span class="text-style" style="margin: 0.32rem 0rem 0.12rem;">계정</span> -->
        <img src="@/assets/img/04p/emai-icon.png" alt="" style="margin: 0.2rem 0rem 0.1rem; height: 0.13rem;">
        <aside style="display: flex; align-items: center; width: 100%;">
          <!-- <span class="text-box">{{ userInfo.uname }}</span> -->
          <input class="input-box" type="text" v-model="bdEmail" placeholder="메일 연동" style="width: 100%;">
        </aside>
        <img src="@/assets/img/04p/code-icon.png" alt="" style="margin: 0.2rem 0rem 0.1rem; height: 0.13rem;">
        <aside style="display: flex; align-items: center; width: 100%;">
          <input class="input-box" type="text" v-model="bdCode" placeholder="이메일 인증번호를 입력해주세요." style="display: block; flex: 1;">
          <button v-if="isWait1" class="btn-box2">{{ count1 + 'S' }}</button>
          <img v-else src="@/assets/img/04p/code-btn.png" alt="" @click="getVerifyCode(303, bdEmail)" style="height: 0.4rem;">
        </aside>
        <span style="display: block; width: 100%; text-align: center; color: rgb(0, 143, 255); font-size: 0.12rem; margin-top: 0.32rem;">이메일 연동을 완료하시면 특별한 연동 보상이 지급됩니다!</span>
      </section>
      <img src="@/assets/img/04p/bd-btn02.png" alt="" @click="getBindCode(303)" style="height: 0.42rem; margin-top: 0.4rem;">
    </section>
    <!-- lingqu -->
    <section class="mask-box" v-if="showBindingGifPop">
      <section class="mask-content">
        <aside style="display: flex; justify-content: flex-end; align-items: center; height: 38px; width: 100%;">
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="showBindingGifPop = false" style="height: 28px; margin-right: 12px;">
        </aside>
        <img src="@/assets/img/04p/lq-title.png" alt="" style="height: 20px; margin-top: 18px;">
        <img src="@/assets/img/04p/send-tips02.png" alt="" style="width: 324px; margin-top: 24px;">
        <span style="font-size: 14px; margin: 12px 0px 24px;">{{ '메일 연동:' + bdEmail }}</span>
        <aside style="display: flex; justify-content: center;">
          <img src="@/assets/img/04p/config-btn.png" alt="" @click="sendGiftCode" style="height: 40px; margin-right: 25px;">
          <img src="@/assets/img/04p/close-btn.png" alt="" @click="showBindingGifPop = false" style="height: 40px; margin-left: 25px;">
        </aside>
      </section>
    </section>
    <!-- xiugai -->
    <section v-if="showType == 'chuangePwd'" style="display: flex; flex-direction: column; align-items: center; width: 342px;">
      <img src="@/assets/img/04p/bac-btn02.png" alt="" @click="showType = 'index'" style="position: absolute; top: 0.56rem; left: 0rem; height: 0.5rem;">
      <img src="@/assets/img/04p/title0201.png" alt="" style="height: 0.54rem; margin-top: 1.06rem;">
      <section style="width: 342px; display: flex; flex-direction: column; align-items: flex-start;">
        <img src="@/assets/img/04p/xg-icon.png" alt="" style="height: 0.18rem; margin-top: 0.2rem;">
        <aside style="display: flex; align-items: center; margin-top: 0.32rem;">
          <span class="ying-text">메일 연동:</span>
          <span style="display: block; color: orange; font-size: 0.13rem;">{{ bingdingEmail }}</span>
          <button @click="showType = 'modifyBinding'" style="background: none; border: none; color: rgb(90, 131, 208); font-size: 0.14rem; margin-left: 12px;">변경</button>
        </aside>
        <!-- <img src="@/assets/img/04p/emai-icon.png" alt="" style="margin: 0.32rem 0rem 0.12rem; height: 0.23rem;"> -->
        <aside style="display: flex; align-items: center; width: 100%; margin-top: 0.16rem; position: relative;">
          <span class="ying-text">새 비밀번호:</span>
          <input class="input-box" :type="showPwd ? 'text' : 'password'" v-model="modifyReq.upwd" minlength="6" maxlength="16" placeholder="새 비밀번호를 입력해주세요" style="display: block; flex: 1;">
          <img v-if="showPwd" src="@/assets/img/04p/look-n.png" alt="" @click="showPwd = false" style="height: 0.12rem; position: absolute; right: 0.24rem;">
          <img v-else src="@/assets/img/04p/look.png" alt="" @click="showPwd = true" style="height: 0.12rem; position: absolute; right: 0.24rem;">
        </aside>
        <aside style="display: flex; align-items: center; width: 100%; margin-top: 0.3rem; position: relative;">
          <span class="ying-text">비밀번호 확인:</span>
          <input class="input-box" :type="showPwd ? 'text' : 'password'" v-model="newPwd" minlength="6" maxlength="16" placeholder="새 비밀번호를 입력해주세요" style="display: block; flex: 1;">
          <img v-if="showPwd" src="@/assets/img/04p/look-n.png" alt="" @click="showPwd = false" style="height: 0.12rem; position: absolute; right: 0.24rem;">
          <img v-else src="@/assets/img/04p/look.png" alt="" @click="showPwd = true" style="height: 0.12rem; position: absolute; right: 0.24rem;">
        </aside>
        <!-- <img src="@/assets/img/04p/code-icon.png" alt="" style="margin: 0.32rem 0rem 0.12rem; height: 0.23rem;"> -->
        <aside style="display: flex; align-items: center; width: 100%; margin-top: 0.3rem;">
          <span class="ying-text">인증코드:</span>
          <input class="input-box" type="text" v-model="modifyReq.scode" placeholder="인증코드 입력" style="display: block; flex: 1;">
          <button v-if="isWait1" class="btn-box2">{{ count1 + 'S' }}</button>
          <img v-else src="@/assets/img/04p/code-btn.png" alt="" @click="getVerifyCode(307, communication.email)" style="height: 0.4rem;">
        </aside>
      </section>
      <img src="@/assets/img/04p/xg-btn02.png" alt="" @click="changePwd()" style="height: 0.4rem; margin-top: 0.6rem;">
    </section>
    <!-- modifybinding -->
    <section v-if="showType == 'modifyBinding'" style="display: flex; flex-direction: column; align-items: center; width: 342px;">
      <img src="@/assets/img/04p/bac-btn02.png" alt="" @click="showType = 'index'" style="position: absolute; top: 0.56rem; left: 0rem; height: 0.5rem;">
      <img src="@/assets/img/04p/title02.png" alt="" style="height: 0.54rem; margin-top: 1.06rem;">
      <section style="width: 342px; display: flex; flex-direction: column; align-items: flex-start;">
        <img src="@/assets/img/04p/bd-icon.png" alt="" style="height: 0.18rem; margin-top: 0.2rem;">
        <aside style="display: flex; align-items: center; margin: 0.2rem 0rem 0.1rem;">
          <span style="display: block; padding-right: 6px; color: rgb(53, 88, 124); font-size: 0.13rem;">메일 연동:</span>
          <span style="display: block; color: orange; font-size: 0.13rem;">{{ bingdingEmail }}</span>
        </aside>
        <aside style="display: flex; align-items: center; width: 100%;">
          <input class="input-box" type="text" v-model="modifyBindingReq.yscode" placeholder="이메일 인증번호를 입력해주세요." style="display: block; flex: 1;">
          <button v-if="isWait2" class="btn-box2">{{ count2 + 'S' }}</button>
          <img v-else src="@/assets/img/04p/code-btn.png" alt="" @click="getVerifyCode(309, communication.email)" style="height: 0.4rem;">
        </aside>
        <img src="@/assets/img/04p/emai-icon.png" alt="" style="margin: 0.2rem 0rem 0.1rem; height: 0.13rem;">
        <aside style="display: flex; align-items: center; width: 100%;">
          <!-- <span class="text-box">{{ userInfo.uname }}</span> -->
          <input class="input-box" type="text" v-model="bdEmail" placeholder="메일 연동" style="width: 100%;">
        </aside>
        <img src="@/assets/img/04p/code-icon.png" alt="" style="margin: 0.2rem 0rem 0.1rem; height: 0.13rem;">
        <aside style="display: flex; align-items: center; width: 100%;">
          <input class="input-box" type="text" v-model="modifyBindingReq.scode" placeholder="이메일 인증번호를 입력해주세요." style="display: block; flex: 1;">
          <button v-if="isWait1" class="btn-box2">{{ count1 + 'S' }}</button>
          <img v-else src="@/assets/img/04p/code-btn.png" alt="" @click="getVerifyCode(304, bdEmail)" style="height: 0.4rem;">
        </aside>
        <aside style="display: flex; justify-content: flex-end; width: 100%;">
          <img src="@/assets/img/04p/help.png" alt="" @click="goCustomer" style="margin: 0.2rem 0rem 0.1rem; height: 0.13rem;"></img>
        </aside>
      </section>
      <img src="@/assets/img/04p/bd-btn02.png" alt="" @click="getUpBindCode(303)" style="height: 0.4rem; margin-top: 0.6rem;">
    </section>
  </section>
</template>

<style scoped>
.trade-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/03p/trade-bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-style {
  color: rgb(53, 88, 124);
  font-size: 0.14rem;
}
.text-box {
  display: block;
  width: 250px;
  height: 0.36rem;
  border: 1px solid rgb(94, 140, 196);
  border-radius: 10px;
  background: #ffffff;
  margin-right: 10px;
  font-size: 14px;
  line-height: 0.36rem;
  text-align: center;
}
.tips-color {
  color: #cdcdcd;
}
.btn-box {
  background: rgb(29, 115, 180);
  border: none;
  border-radius: 12px;
  height: 0.36rem;
  width: 74px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0px 0px 2px 2px #cdcdcd;
}
.btn-box2 {
  background: #cdcdcd;
  border: none;
  border-radius: 12px;
  height: 0.36rem;
  width: 74px;
  color: #898989;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0px 0px 2px 2px #cdcdcd;
}
.input-box {
  display: block;
  height: 0.38rem;
  border: 1px solid rgb(94, 140, 196);
  border-radius: 8px;
  background: #ffffff;
  margin-right: 10px;
  font-size: 0.13rem;
  line-height: 0.64rem;
  text-align: center;
}
.mask-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 80%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask-content {
  width: 342px;
  height: 294px;
  background: url('../../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ying-text {
  display: block;
  width: 90px;
  padding-right: 6px;
  color: rgb(53, 88, 124);
  font-size: 0.13rem;
  text-align: right;
}
</style>
